import { ThemeSection } from '@easeltv/client-sdk';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { Button } from '../../typography';

interface SharedLinkProps {
    $hasBackground: boolean;
    section: ThemeSection;
    $cta: boolean;
}

export const SharedLinkStyles = css<SharedLinkProps>(
    ({ $hasBackground, $cta, section }) => css`
        display: inline-block;
        border-radius: 8px;
        padding: ${$hasBackground || $cta ? '0.375rem 0.625rem' : '0'};
        background: ${$hasBackground || $cta ? section.feature : 'none'};
        color: ${$hasBackground || $cta ? section.featureText : section.a};
        text-decoration: none;
        transition: all 0.33s;
        white-space: nowrap;

        display: flex;
        align-items: center;

        > img {
            height: 2.25rem;
        }

        &:has(> img + span) {
            > img {
                margin-right: 0.675rem;
            }
        }

        &:hover {
            @media (hover: hover) {
                ${$hasBackground
                    ? `background: ${section.featureMouseover}`
                    : null};
                ${$hasBackground
                    ? `color: ${section.featureMouseoverText}`
                    : `color: ${section.featureMouseover}`};
            }
        }
    `,
);

export const StyledInternalLink = styled(Link)`
    ${SharedLinkStyles};
`;

export const StyledExternalLink = styled.a`
    ${SharedLinkStyles};
`;

export const StyledButtonLink = styled(Button)`
    ${SharedLinkStyles};
`;
